import { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
// @mui
import Box from '@mui/material/Box';
//
import groovyWalkAnimation from '../../_json/loading-animation.json';

/* =========================================================================== */


export default function SplashScreen({ sx, ...other }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0, right: 0, bottom: 0, left: 0,
        px: 5,
        flexGrow: 1,
        minHeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        margin: 'auto',
        width: '100%',
        height: 'auto',
      }}
      {...other}
    >
      <Lottie animationData={groovyWalkAnimation} loop={Boolean(true)} />
    </Box>
  );
}
